/** BLOOD technology partnership — evaluation deposit (client-safe constants). */

export const BLOOD_EVALUATION_DEPOSIT_CENTS = 500_000; // $5,000
export const BLOOD_EVALUATION_DEPOSIT_USD = BLOOD_EVALUATION_DEPOSIT_CENTS / 100;
export const BLOOD_FULL_EVALUATION_USD = 35_000;
export const BLOOD_PATENT = 'US Patent Application 18/901,437';

export const BLOOD_ORGANIZATION_TYPES = [
  'Humanoid robotics OEM',
  'Research institution',
  'Defense / aerospace',
  'Semiconductor / hardware',
  'Venture / strategic investor',
  'Other',
] as const;

export type BloodOrganizationType = (typeof BLOOD_ORGANIZATION_TYPES)[number];

export type BloodEvaluationIntake = {
  contactName: string;
  email: string;
  company: string;
  jobTitle: string;
  organizationType: BloodOrganizationType;
  useCase: string;
};

export const BLOOD_EVALUATION_INCLUDES = [
  'NDA and technology overview briefing',
  'Architecture brief for humanoid / advanced compute use cases',
  '90-day evaluation window with SELF Labs team',
  `$${BLOOD_EVALUATION_DEPOSIT_USD.toLocaleString()} credited toward full evaluation ($${BLOOD_FULL_EVALUATION_USD.toLocaleString()}) or dev license if you proceed`,
] as const;
